<mat-sidenav-container>
  <mat-sidenav [mode]="sideNavMode"
               [position]="sideNavPosition"
               [(opened)]="sidePanelOpened"
               class="search-panel"
               #sideNavPanel>
    <rlst-search-panel [sidePanelOpened]="sidePanelOpened"
                       [sidePanelTabOpened]="sidePanelTabOpened"
                       [currentCounty]="selectedCounty$ | async"
                       [currentCountyTooltip]="selectedCountyTooltip$ | async"
                       [totalGridRecords]="totalGridRecords$ | async"
                       [searchResultsCount]="searchResultsCount$ |async"
                       [currentGridPage]="currentGridPage$ | async"
                       [isLoginInProgress]="isLoginInProgress$ | async"
                       (toggledSidePanel)="toggleSidePanel()"
                       (sidePanelTab)="openTab($event)"
                       (changeGridPage)="changeGridPage($event)"
                       (clearSearchResults)="clearSearchResults()"
                       class="d-flex flex-column h-100">
    </rlst-search-panel>
  </mat-sidenav>
  <mat-sidenav-content>
    <div class="toggle-wrapper-closed d-none d-md-block">
      <button type="button"
              [ngClass]="{'toggle-wrapper-closed__btn--hidden': sidePanelOpened}"
              class="toggle-wrapper-closed__btn p-0"
              rlstTooltip="Expand Search Bar"
              tooltipPosition="right"
              (click)="toggleSidePanel()">
        <i class="fa fa-search" aria-hidden="true"></i>
        <span class="sr-only">Expand search bar</span>
      </button>
    </div>
    <header class="grid-header d-flex justify-content-between flex-column-reverse flex-md-row pr-0"
            [ngClass]="{
              'p-0': sidePanelOpened || isMobile,
              'grid-header_mobile-map': gridState.map === gridItemSize.FULL
            }">
      <rlst-search-map-menu
        class="rlst-search-map-menu"
        *ngIf="!(isMobile && gridState.list === gridItemSize.FULL) && mapIsLoaded"
        [selectedDrawingTool]="selectedDrawingTool"
        [hasClearAll]="hasClearAll$ | async"
        (useAnnotationTool)="useAnnotationTool()"
        (clearSelectedLayers)="clearSelectedLayers()"
        (useDrawingTool)="useDrawingTool($event)"
        (locateOnMapTool)="locateOnMapToolEvent($event)">
      </rlst-search-map-menu>
      <div class="grid-header__buttons d-flex align-items-center">
        <button class="btn-header d-none d-md-block"
                [class.active]="gridState.list !== gridItemSize.FULL && gridState.map !== gridItemSize.FULL"
                aria-label="Split View"
                data-tooltip-position="below"
                (click)="changeGridView(gridItemSize.HALF, gridItemSize.HALF)">
          <span class="btn-header__label">
            Split
          </span>
        </button>
        <button class="btn-header"
                [class.active]="gridState.map === gridItemSize.FULL"
                aria-label="Map View"
                data-tooltip-position="below"
                (click)="changeGridView(gridItemSize.FULL, gridItemSize.ZERO)">
          <span class="btn-header__label">
            <i class="fa fa-map d-inline d-md-none" aria-hidden="true"></i>
            Map
          </span>
        </button>
        <button class="btn-header"
                [class.active]="gridState.list === gridItemSize.FULL"
                aria-label="List View"
                data-tooltip-position="below"
                (click)="changeGridView(gridItemSize.ZERO, gridItemSize.FULL)">
          <span class="btn-header__label">
            <i class="fa fa-th-large d-inline d-md-none"></i>
            List
          </span>
        </button>
      </div>
    </header>
    <as-split direction="vertical"
              class="dashboard-container"
              [ngClass]="{'no-action-bar': gridState.map === gridItemSize.FULL}"
              [gutterSize]="12"
              [useTransition]="!isMobile"
              [disabled]="isMobile"
              (dragEnd)="gridDragEnd($event)">
      <as-split-area class="position-relative"
                     [size]="gridState.map"
                     [order]="1"
                     [ngClass]="{'fix-as-split-area': isMobile && gridState.map}">
        <rlst-map *ngIf="key$ | async"
                  (mapIsLoaded)="setMapIsLoaded()"
                  [isMobile]="isMobile"
                  [checkedProperties]="checkedProperties$ | async"
                  [clearPOI]="hasClearAll$">
        </rlst-map>
      </as-split-area>
      <as-split-area [size]="gridState.list"
                     [order]="2"
                     class="position-relative overflow-hidden"
                     [ngClass]="{'fix-as-split-area': isMobile && gridState.list}"
                     *ngIf="(userInfo$ | async) as userInfo">
        <div class="d-flex justify-content-between align-items-center grid-header grid-header-m-white"
             *ngIf="!isMobile || (paginatedRowData$ | async).length"
             [ngClass]="{'pl-0': sidePanelOpened && !isMobile}">
          <div class="search-results d-flex align-items-center pl-3">
            <div *ngIf="!isMobile">
              <span>{{totalGridRecords$ | async}} results</span>
              <span class="sep">|</span>
              <span> {{selectedRecords$ | async}} selected</span>
            </div>
            <div *ngIf="isMobile" class="total-records-mobile">
              <span>{{(checkedPropertyIdList$ | async).length}}/{{(paginatedRowData$ | async).length}}</span>
            </div>
            <div class="d-flex" *ngIf="!(selectedResultsTableView$ | async)">
              <span class="sep">|</span>
              <label class="custom-checkbox align-items-center" [ngClass]="{'custom': !isMobile }">
                <input type="checkbox"
                       class="custom-control-input checkbox-default"
                       [checked]="showSelectAllButton$ | async"
                       [disabled]="disableSelectAllButton$ | async"
                       (click)="onSelectAll($event)">
                <span class="custom-control-indicator"></span>
                <span class="pl-2">Select all</span>
              </label>
            </div>
          </div>
          <div class="search-customize d-flex justify-content-center align-items-center">
            <button type="button" *ngIf="selectedResultsTableView$ | async"
                    class="btn-icon btn-customize"
                    [matMenuTriggerFor]="customizeTable">
              <i class="far fa-sliders-h" aria-hidden="true"></i>
              <span class="d-none d-lg-inline">Customize Table</span>
            </button>
            <mat-menu #customizeTable="matMenu" class="primary-mat-menu">
              <button type="button" mat-menu-item
                      (click)="openCustomizeTableModal()">
                Show/Hide Columns
              </button>
              <button type="button" mat-menu-item [disabled]="isShowSelectedDisabled$ | async"
                      (click)="showSelectedProperties()">
                Show Only Selected Rows
              </button>
              <button type="button" mat-menu-item [disabled]="!(showSelected$ | async)"
                      (click)="showAllProperties()">
                Reset to Default List
              </button>
              <button type="button" mat-menu-item
                      (click)="toggleCompactMode()">
                {{ isCompactMode ? "Default Mode" :  "Compact Mode" }}
              </button>
            </mat-menu>
            <ng-container *ngIf="!(selectedResultsTableView$ | async)">
              <button class="btn-icon btn-customize d-mobile"
                      [disabled]="isEmailDisabled"
                      (click)="openEmailModal()">
                <i class="far fa-envelope" aria-hidden="true"></i>
                <span class="sr-only">Send email</span>
              </button>
              <button class="btn-icon btn-customize d-mobile"
                      (click)="openSortModal()">
                <i class="far fa-sort" aria-hidden="true"></i><span class="sr-only">Sort</span>
              </button>
              <button class="btn-icon btn-customize"
                      (click)="openCustomizeCardModal()">
                <i class="far fa-sliders-h" aria-hidden="true"></i>
                <span class="d-none d-lg-inline">Customize Cards</span>
              </button>
            </ng-container>

            <div class="d-none d-md-flex align-items-center">
              <span class="sep">|</span>
              <button class="d-flex justify-content-center align-items-center btn-header"
                      [class.active]="selectedResultsTableView$ | async"
                      rlstTooltip="Table View"
                      tooltipPosition="left"
                      (click)="changeResultsView()">
                          <span class="btn-header__label">
                            <i class="fa fa-bars" aria-hidden="true"></i>
                            <span class="sr-only">Table view</span>
                          </span>
              </button>
              <button class="d-flex justify-content-center align-items-center btn-header"
                      [class.active]="!(selectedResultsTableView$ | async)"
                      rlstTooltip="Cards View"
                      tooltipPosition="left"
                      (click)="changeResultsView()">
                <span class="btn-header__label">
                  <i class="fa fa-th-large" aria-hidden="true"></i>
                  <span class="sr-only">Cards View</span>
                </span>
              </button>
            </div>
          </div>
        </div>
        <!-- @TODO: change 'userFieldsPreference' in integration gridModal v.novikov-->
        <rlst-grid *ngIf="!isMobile && selectedResultsTableView$ | async"
                   [rowData]="rowData$ | async"
                   [checkedProperties]="checkedPropertyIdList$ | async"
                   [userFieldsPreference]="gridHeaders$ | async"
                   [indicatorFlagsPreference]="indicatorFlagsPreference$ | async"
                   [currentRowId]="rowId$ | async"
                   [sideNav]="sideNavPanel"
                   [resizeColumns]="sidePanelOpened"
                   [currentPage]="currentGridPage$ | async"
                   [isCompactMode]="isCompactMode"
                   (openForeclosureReport)="openForeclosureReport()"
                   (openPropertyDetailsReport)="openPropertyDetailsReport($event)">
        </rlst-grid>
        <ng-container *ngIf="!isMobile || (paginatedRowData$ | async).length; then filledPropertyPanel else emptyPropertyPanel"></ng-container>
      </as-split-area>
    </as-split>
    <rlst-action-bar *ngIf="!isMobile"
                     [checkedProperties$]="checkedProperties$"
                     [reportsWithMapDisabled]="gridState.list === gridItemSize.FULL"
                     reportType="dashboard"
                     class="action-bar-container"></rlst-action-bar>
  </mat-sidenav-content>
</mat-sidenav-container>


<ng-template #filledPropertyPanel>
  <div class="property-panel__scroll-container">
    <rlst-property-panel
      *ngIf="isMobile || !(selectedResultsTableView$ | async)"
      [sidePanelOpened]="sidePanelOpened"
      [currentRowId]="rowId$ | async"
      [userFieldsPreference]="customCardsAttributes$ | async"
      [rowData]="paginatedRowData$ | async"
      [isMobile]="isMobile"
      [checkedProperties]="checkedPropertyIdList$ | async"
      [savedProperties]="savedPropertyIdList"
      [saveShown]="true"
      [getPropertyId]="getIdFromPropertyInformation"
      (toggleChecked)="toggleChecked($event)"
      (toggleSaved)="toggleSaved($event)"></rlst-property-panel>
  </div>
</ng-template>

<ng-template #emptyPropertyPanel>
  <div class="d-flex flex-column justify-content-center align-items-center h-100 w-100 empty-property-panel" (click)="startToSearch()">
    <img src="assets/img/mobile_search_placeholder.png" alt="Start to search" class="empty-property-panel-img">
    <span class="empty-property-panel-text">Start to search</span>
  </div>
</ng-template>

<rlst-survey></rlst-survey>
